export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_07.78d26dc2.jpg";